import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import {
  fetchImageSlidersList,
  addImageSlider,
  clearAddImageSlider,
} from 'redux/image-sliders/actions';

import { Link } from 'react-router-dom';

import OutsideHandler from 'components/common/OutsideHandler';
import Button from 'components/elements/buttons/Button';
import CommonMessage from 'components/common/CommonMessage';

import './AddImageSlider.css';

const AddImageSlider = props => {
  const {
    me,
    fetchImageSlidersList,
    addImageSlider,
    clearAddImageSlider,
    addImageSliderSuccess,
    addImageSliderError,
    imageSlidersList,
  } = props;
  const { t } = useTranslation();

  const [dropDownOpened, setDropDownOpened] = useState(false);

  useEffect(() => {
    return () => {
      clearAddImageSlider();
    };
  }, []);

  useEffect(() => {
    if (addImageSliderSuccess) {
      fetchImageSlidersList();
      clearAddImageSlider();
    }
  }, [addImageSliderSuccess]);

  const renderAddButton = () => {
    if (
        me &&
        me.subscription &&
        !me.subscription.ff_slider &&
        imageSlidersList &&
        imageSlidersList.length > 0
    ) return null;

    return (
      <div className="add-button-container">
        <Button
          onClick={() => {setDropDownOpened(!dropDownOpened);}}
          borderedBlue={imageSlidersList && imageSlidersList.length > 0}
        >
          <div className="icon" />
            <div>
              {(imageSlidersList && imageSlidersList.length > 0) ? t("Add another Gallery")
                : t("Add Gallery")}
            </div>
          </Button>

          {dropDownOpened &&
            <OutsideHandler handleClickOutside={() => setDropDownOpened(false)}>
              <div className="button-dropdown">
                <div
                  className="dropdown-item"
                  onClick={() => {
                    addImageSlider('instagram');
                    setDropDownOpened(false);
                  }}
                  role="button"
                  tabIndex={-1}
                >
                  <div className="icon instagram" />
                  <div className="text-wrapper">
                    <div className="title">{t('Add Instagram Profile')}</div>
                    <div className="text">
                      {t('Add Istagram Profile to embed on your Heylink.me recent posts')}
                    </div>
                  </div>
                </div>
                <div
                  className="dropdown-item"
                  onClick={() => {
                    addImageSlider('slider');
                    setDropDownOpened(false);
                  }}
                  role="button"
                  tabIndex={-1}
                >
                  <div className="icon slider" />
                  <div className="text-wrapper">
                    <div className="title">{t('Image Slider')}</div>
                    <div className="text">
                      {t('Display many images on your Heylink.me')}
                    </div>
                  </div>
                </div>
              </div>
            </OutsideHandler>

          }
        </div>
    );
  };

  return (
    <div className="add-image-slider__component">
      <div className="wrapper">
        {/* Buttons Block */}
        {renderAddButton()}

        {/* Messages */}
        <div className="message">
          {(me && me.subscription && !me.subscription.ff_slider) ?
            <div className="starter-text">
              <div className="text">
                {t("You can add multiple Image Sliders on the PRO plan.")}
                {t("Check it ")}<Link to="/billing">{t("here")}</Link>
              </div>
            </div>
            :
            <div className="starter-text">
              <div className="text">
                {t("You are PRO")}!
                {t("You can add several Image Sliders")}
              </div>
            </div>
          }
        </div>
      </div>

      {/* Add Error */}
      {addImageSliderError &&
        <CommonMessage
          error
          errors={addImageSliderError}
        />
      }
    </div>
  );
};

AddImageSlider.propTypes = {
  fetchImageSlidersList: PropTypes.func.isRequired,
  addImageSlider: PropTypes.func.isRequired,
  clearAddImageSlider: PropTypes.func.isRequired,
  me: PropTypes.object,
  addImageSliderSuccess: PropTypes.object,
  addImageSliderError: PropTypes.object,
  imageSlidersList: PropTypes.arrayOf(PropTypes.shape),
};

AddImageSlider.defaultProps = {
  me: null,
  addImageSliderSuccess: null,
  addImageSliderError: null,
  imageSlidersList: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    addImageSliderSuccess: state.imageSlidersReducer.addImageSliderSuccess,
    addImageSliderError: state.imageSlidersReducer.addImageSliderError,
    imageSlidersList: state.imageSlidersReducer.imageSlidersList,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchImageSlidersList,
    addImageSlider,
    clearAddImageSlider,
  },
)(AddImageSlider);
